//ios
 var setupWebViewJavascriptBridge = (callback) => {
    if (window.WebViewJavascriptBridge) {
        return callback(WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe)
    }, 0)
}
export default setupWebViewJavascriptBridge
setupWebViewJavascriptBridge();

//安卓注册事件监听
// function connectWebViewJavascriptBridge(callback) {
//     if (window.WebViewJavascriptBridge) {
//         callback(WebViewJavascriptBridge)
//     } else {
//         document.addEventListener(
//             'WebViewJavascriptBridgeReady',
//             function () {
//                 callback(WebViewJavascriptBridge)
//             },
//             false
//         );
//     }
// }
// //注册回调函数，第一次连接时调用 初始化函数
// connectWebViewJavascriptBridge(function (bridge) {
//     //初始化
//     bridge.init(function (message, responseCallback) {
//         //var data = {'Javascript Responds': 'Wee!'};
//         responseCallback(data);
//     });
//     //Android调用js方法：functionInJs方法名称需要保持一致 ，并返回给Android通知
//     bridge.registerHandler("functionInJs", function (data, responseCallback) {
//         responseCallback(data);
//     });
// })